import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, DoCheck, OnChanges, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import {IMyDefaultMonth, INgxMyDpOptions } from '@mksasi/ngx-mydatepicker';
import { ValidationService } from '../../validators/validation.service';
import { AppService } from "src/app/services/services";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { EncryptionService } from "src/app/services/encryption.service";
import { ErrorModalComponent } from "src/app/common/error-modal/error-modal.component";

@Component({
    selector: 'nri-app-ri-details',
    templateUrl: './ri-details.component.html',
    styleUrls: ['./ri-details.component.scss']
})

export class RIDetailsComponent implements  OnInit{
    @Output() stageComplete = new EventEmitter();
    agreeBankStage: boolean = false;
    acStatus: string = '';
    bankResponse: any;
    closeRI: any;
    customerID: string = '';
    customerIDError: boolean = false;
    dpidToggle: boolean = false;
    dpIndex: number = 0;
    erefNo: string = '';
    existingDemat: boolean;
    existingRI: boolean = false;
    getnreNPIS: boolean = false;
    getnrePIS: boolean = false;
    getnroNPIS: boolean = false;
    getnroPIS: boolean = false;
    nrePIS: boolean;
    nreNPIS: boolean;
    nroPIS: boolean;
    nroNPIS: boolean;
    nropisac: string = '';
    nrepisac: string = '';
    nronpisac: string = '';
    nrenpisac: string = '';
    nronpisacError: boolean;
    nropisacError: boolean;
    nrenpisacError: boolean;
    nrepisacError: boolean;
    panNumber: string = '';
    ri: boolean = false;
    selectedDPID: number;
    tradingAccNo: string = '';
    riError: boolean;
    @ViewChild('errorComp') errorComp : ErrorModalComponent;
    constructor(private _http: AppService,  private loader: NgxUiLoaderService,private toastr: ToastrService, private router: Router, private http:EncryptionService){
        this._http.getRefNum().subscribe(data=>{
            this.erefNo = data;
        });
        
        this._http.getStatus().subscribe(data=>{
            this.panNumber = data.Pan;
        })
    }

    ngOnInit() { 
        this.geAccountTypes();   
    }

    geAccountTypes(){
        let url = "DIY/SubAcVerify";

        let params = {
            "ReferenceNumber": this.erefNo,
            "PanNumber": this.panNumber
        }

        let checkSum = this.erefNo + this.panNumber;
        this.loader.start();
        this._http.httpPost(url, params, checkSum).subscribe({
            next: (data:any)=>{
                this.loader.stop();
                let subAcVal = this.http.decryptUsingAES256(data.OutPut);
                if(subAcVal && subAcVal.ExistingDemat){ 
                    this.existingDemat = subAcVal.ExistingDemat;
                    this.bankResponse = subAcVal.BankResponses;
                    this.existingRI = subAcVal.RI;
                    if(subAcVal.NRE_NONPIS){
                        this.getnreNPIS = true;
                    }

                    if(subAcVal.NRE_PIS){
                        this.getnrePIS = true;
                    }

                    if(subAcVal.NRO_NONPIS){
                        this.getnroNPIS = true;
                    }

                    if(subAcVal.NRO_PIS){
                        this.getnroPIS = true;
                    }
                }else{
                    this.router.navigate(['/fatca'], { replaceUrl: true });
                }
                this.getDemat()
            },
            error: _error =>{
                this.loader.stop();
            }
        })
    }

    getDemat(){
        let url = "DIY/DIYExistingDemat";

        let params = {
            "ReferenceNumber": this.erefNo
        }

        let checkSum = this.erefNo;
        
        this._http.httpPost(url, params, checkSum).subscribe({
            next: (data:any)=>{
                let ExistingDematVal = this.http.decryptUsingAES256(data.OutPut)
                if(data){
                    this.selectedDPID = ExistingDematVal.DPId;
                    this.customerID = ExistingDematVal.CusDId;
                    this.tradingAccNo = ExistingDematVal.TradingId;
                    this.existingRI = ExistingDematVal.IsExistingRI;
                    this.acStatus = ExistingDematVal.CON_Ex_Demat_NRI ? 'convert' : ExistingDematVal.CloseRI ? 'close' : ExistingDematVal.IsExistingNRI ? 'create': ExistingDematVal.LinkExistingNRI ? 'link': '';
                }
            }
        })
    }

    disableInput(i:number){
        setTimeout(()=>{
            this.customerID = this.bankResponse[i].CLIENT_ID;
            this.tradingAccNo = this.bankResponse[i].DEMAT_ACC_NO;
        },100)
    }

    backStage(){
        this.router.navigate(['/bank'])
    }

    setDPID(i: number){
        this.dpidToggle = false;
        this.selectedDPID = this.bankResponse[i].CLIENT_EXCH_ID;
        this.customerID = this.bankResponse[i].CLIENT_ID;
        this.tradingAccNo = this.bankResponse[i].DEMAT_ACC_NO;
        this.dpIndex = i;
    }

    dropToggle(){
        this.dpidToggle = !this.dpidToggle
    }

    stageValidate(){
       if(!this.acStatus){
            this.riError = true;
        }else{
            let url = 'DIY/DIYUpdtDemat';

            let params = {
                "ReferenceNumber": this.erefNo,
                "DPId": this.selectedDPID,
                "CusDId": this.customerID,
                "TradingId":this.tradingAccNo,
                "IsExistingRI": this.existingRI,
                "CON_Ex_Demat_NRI": this.acStatus === 'convert' ? true: false,
                "CloseRI": this.acStatus === 'close' ? true: false,
                "IsExistingNRI": this.acStatus === 'create' ? true: false,
                "LinkExistingNRI": this.acStatus === 'link' ? true: false,
            }
    
            let checkSum =  this.selectedDPID+this.erefNo+this.customerID+this.tradingAccNo;
    
            this._http.httpPost(url, params, checkSum).subscribe({
                next:(data:any)=>{
                    let stageVal = this.http.decryptUsingAES256(data.OutPut)
                    if(stageVal.IsSuccess){
                        this.router.navigate(['/fatca'], { replaceUrl: true });
                    }
                },
                error: error=>{
                    // this.toastr.error(error.error.Message)
                    // this.toastr.error("It appears that your internet connectivity is slow or please try again.")
                    this.errorComp.ModalShow("It appears that your internet connectivity is slow or please try again.");
                }
            })
        }
    }

    knowMore(type: string){
        if(type === 'closure'){
            window.open('./assets/Trading_Closure_Form.pdf', '_blank');
        }else{
            window.open('./assets/Conversion_of_demat_account_from_RI_to_NRI.pdf', '_blank')
        }
    }
}